import { render, staticRenderFns } from "./UploaderState.vue?vue&type=template&id=4c0aeb01&scoped=true&lang=pug"
import script from "./UploaderState.vue?vue&type=script&lang=ts"
export * from "./UploaderState.vue?vue&type=script&lang=ts"
import style0 from "./UploaderState.vue?vue&type=style&index=0&id=4c0aeb01&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0aeb01",
  null
  
)

export default component.exports